const DEFAULT_MAX_FRACTION = 0.28;

/**
 * Overlay size (0–1 of canvas) whose on-canvas pixels match the image
 * aspect ratio, contained in a maxFraction slot of the artboard.
 */
export const fitImageOverlayBox = ({
  imageWidth,
  imageHeight,
  canvasWidth,
  canvasHeight,
  maxFraction = DEFAULT_MAX_FRACTION,
} = {}) => {
  const imgW = Math.max(1, Number(imageWidth) || 1);
  const imgH = Math.max(1, Number(imageHeight) || 1);
  const boardW = Math.max(1, Number(canvasWidth) || 1);
  const boardH = Math.max(1, Number(canvasHeight) || 1);
  const fraction = Math.min(
    1,
    Math.max(0.02, Number(maxFraction) || DEFAULT_MAX_FRACTION)
  );
  const scale = Math.min(
    (boardW * fraction) / imgW,
    (boardH * fraction) / imgH
  );
  return {
    nw: (imgW * scale) / boardW,
    nh: (imgH * scale) / boardH,
  };
};

/**
 * Overlay box (0–1) that keeps the new image aspect ratio and contain-fits
 * it into the previous layer: one side matches the original box, the other
 * shrinks. The result stays centered on the old layer and clamped to the artboard.
 */
export const sizeOverlayBoxToNaturalImage = ({
  imageWidth,
  imageHeight,
  canvasWidth,
  canvasHeight,
  currentNx = 0,
  currentNy = 0,
  currentNw = 0,
  currentNh = 0,
} = {}) => {
  const imgW = Math.max(1, Number(imageWidth) || 1);
  const imgH = Math.max(1, Number(imageHeight) || 1);
  const boardW = Math.max(1, Number(canvasWidth) || 1);
  const boardH = Math.max(1, Number(canvasHeight) || 1);
  const boxNw = Math.max(0, Number(currentNw) || 0);
  const boxNh = Math.max(0, Number(currentNh) || 0);
  const boxW = boxNw > 0 ? boxNw * boardW : boardW;
  const boxH = boxNh > 0 ? boxNh * boardH : boardH;
  const scale = Math.min(boxW / imgW, boxH / imgH);
  const nw = (imgW * scale) / boardW;
  const nh = (imgH * scale) / boardH;
  const cx = Number(currentNx) + (boxNw || nw) / 2;
  const cy = Number(currentNy) + (boxNh || nh) / 2;
  const nx = Math.min(Math.max(cx - nw / 2, 0), Math.max(0, 1 - nw));
  const ny = Math.min(Math.max(cy - nh / 2, 0), Math.max(0, 1 - nh));
  return { nx, ny, nw, nh };
};

